<mat-card>
  <mat-card-header *ngIf="!widget.meta.hideTitle">
    <mat-card-title
      *ngIf="!changeTitle; else editTitleWidget"
      [matTooltip]="'dashboard.operational.widgets.doubleClickToEditTitle' | t"
      matTooltipPosition="above"
      (dblclick)="editTitle()"
      class="editTitle"
      >{{ widget.name }}
      <sn-icon size="xs">edit</sn-icon>
    </mat-card-title>
    <button mat-flat-button *ngIf="canChange" (click)="edit()">{{ 'dashboard.operational.widgets.editContent' | t }}</button>
  </mat-card-header>
  <mat-card-content [innerHTML]="sanitizedContent"> </mat-card-content>
</mat-card>
<ng-template #editTitleWidget>
  <sn-form-edit-title
    [widget]="widget"
    [viewId]="viewId"
    (title)="setTitle($event)"
    (updateTitle)="setUpdateTitle($event)"
  ></sn-form-edit-title>
</ng-template>
